export default __webpack_public_path__ + "static/media/confetti.42d2aa2a.png";